import { cn } from "@/utils";
import { graphql, useStaticQuery } from "gatsby";
import React from "react";

import { clientContainer, logoContainer, clientLogo } from "./slider.module.css";
import { Display, H5 } from "@components/ui/typography";

interface ClientSlider {
  years: number;
  logo: {
    localFile: {
      publicURL: string;
    };
    alternativeText: string;
  };
}
interface ClientSliderQuery {
  allStrapiClientSlider: {
    nodes: ClientSlider[];
  };
}
interface ClientsLogosProps extends React.HTMLProps<HTMLDivElement> {}

const ClientsLogos: React.FC<ClientsLogosProps> = ({ className, ...props }) => {
  const data: ClientSliderQuery = useStaticQuery(graphql`
    query clientSlider {
      allStrapiClientSlider {
        nodes {
          id
          years
          logo {
            localFile {
              publicURL
            }
            alternativeText
          }
        }
      }
    }
  `);
  const slider = data.allStrapiClientSlider.nodes;
  return (
    <div className={cn("whitespace-nowrap", className)} {...props}>
      {slider.map((sliderData, index) => (
        <div key={index} className={clientContainer}>
          <div className={logoContainer}>
            <img
              src={sliderData.logo.localFile.publicURL}
              alt={sliderData.logo.alternativeText}
              className={`${clientLogo}`}
            />
          </div>
          <div className="text-center">
            <Display className="mt-4">{sliderData.years}</Display>
            <H5 className="mt-2">years</H5>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ClientsLogos;
